export default "__VITE_ASSET__rfwIX90C__"